import { create } from 'zustand';

interface UnseenCountState {
  readonly unseenCount: number;
}

const useUnseenCountStore = create<UnseenCountState>(() => ({
  unseenCount: 0,
}));

export const useUnseenCount = (): number => useUnseenCountStore((state) => state.unseenCount);
export const setUnseenCount = (unseenCount: number): void => useUnseenCountStore.setState({ unseenCount });
